<template>
    <div class="job-type-popper" @mouseleave="leaveType()">
        <el-scrollbar class="type-list">
            <div
                :class="['type-item flex-center', { active: item.value === active }]"
                v-for="item in typeList"
                :key="item.value"
                @mouseenter="enterType(item)"
            >
                {{ item.label }}

                <i class="el-icon-caret-right"></i>
            </div>
        </el-scrollbar>

        <el-scrollbar class="detail-list" v-if="detailData">
            <div class="detail-title">{{ detailData.label }}</div>

            <div class="detail-option" v-for="option in detailData.children" :key="option.value">
                <div class="option-title">{{ option.label }}</div>

                <div class="option-children">
                    <div class="children-item" v-for="children in option.children" :key="children.value" @click="checkType(children)">
                        {{ children.label }}
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import JobTypeJSON from "@/json/job-type.json";

export default {
    data() {
        return {
            typeList: JobTypeJSON,
            active: undefined,
        };
    },

    computed: {
        detailData() {
            if (!this.active) return null;

            const data = this.typeList.find((item) => item.value === this.active);

            return data || null;
        },
    },

    methods: {
        enterType(type) {
            this.active = type.value;
        },

        leaveType() {
            this.active = undefined;
        },

        checkType(check) {
            this.$emit("check", check);
        },
    },
};
</script>

<style lang="scss" scoped>
.job-type-popper {
    height: 242px;
    display: flex;
    gap: 4px;

    * {
        box-sizing: border-box;
    }

    ::v-deep(.el-scrollbar__wrap) {
        margin: 0 !important;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .type-list,
    .detail-list {
        height: 100%;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
    }

    .type-list {
        width: 168px;

        .type-item {
            width: 100%;
            height: 36px;
            justify-content: space-between;
            padding-inline: 16px 16px;
            cursor: pointer;

            i {
                font-size: 12px;
            }

            &:hover,
            &.active {
                color: #00a6a7;
                background-color: rgba(0, 166, 167, 0.05);
            }
        }
    }

    .detail-list {
        width: 610px;
        padding: 16px;

        .detail-title {
            font-size: 16px;
        }

        .detail-option {
            line-height: 20px;
            padding-block: 16px;
            display: flex;

            .option-title {
                width: 120px;
                display: flex;
                flex-shrink: 0;
            }

            .option-children {
                display: flex;
                flex-wrap: wrap;
                gap: 8px 16px;

                .children-item {
                    cursor: pointer;

                    &:hover {
                        color: #00a6a7;
                    }
                }
            }

            & + .detail-option {
                border-top: 1px solid rgba(0, 0, 0, 0.05);
            }
        }
    }
}
</style>
